import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./style.css";
import { ClientPicker, ReactTable } from "../../Components/Molecules";
import { Breadcrumb, SuccessPopupModal } from "../../Components/Atoms";
import { Button } from "@chakra-ui/react";
import { CLIENT_DRIVERS_HEADERS } from "../../Library/tableHeaders";
import PATHS from "../../Routes/paths";
import { getDriversInfo, assignDriver } from "../../APIs/index";
import { AddIcon } from "../../Assets/images/svgs";
import { getFilters } from "../../Library/tableHelpers";
import { StoreContext } from "../../Library/contexts";

const breadcrumbPaths = [
  { idx: 1, name: "Lease", link: "/" },
  { idx: 2, name: "Client Drivers", link: "", isCurrentPage: true },
];

const Profile = () => {
  const navigate = useNavigate();
  const searchParams = useRef(new URLSearchParams(window.location.search));
  const vehicle = searchParams.current.get('vid');

  const { filters } = useContext(StoreContext);

  const [ drData, setDrData ] = useState([]);
  const [ showLoading, setShowLoading ] = useState(true);
  const [ selectedRows, setSelectedRows ] = useState([]);
  const [ driverAdded, setDriverAdded ] = useState({});

  const [ error, setError ] = useState("");

	const columns = React.useMemo(() => Object.values(CLIENT_DRIVERS_HEADERS).map(header => {
    return {
      Header: header.nm,
      accessor: header.key,
      disableSortBy: !header.sorting,
      Cell: (row) => {
        if (header.navigate) {
          return <Link className="text-blue" to={`${PATHS.LEASE}/${PATHS.DRIVERS}/${PATHS.DRIVER_STATS}?idx=${row.row.original.idx}`} >{row.value}</Link>
        }

        if (header.key === "outsdAmt") {
          return (row.value || 0).toLocaleString();
        }

        return row.value || "-"
      },
      ...getFilters(header),
    };
  }), []);

  useEffect(() => {
    const fetchDrivers = (clientId) => {
      getDriversInfo(clientId, null, !!vehicle, null, (err, resp) => {
        if (err) console.error(err);
        else {
          setShowLoading(false);
          setDrData(resp);
        }
      })
    }

    fetchDrivers(filters.client);
  }, [ filters.client, vehicle ])

  const handleDriverAssign = (drivers) => {
    if (!drivers || !drivers.length) setError("Please select driver to assign");
    else if (drivers.length > 1) setError("Cannot Assign Multiple Drivers to 1 Vehicle");
    else {
      assignDriver({ drId: drivers[0].original.idx, vid: vehicle },  (err, resp) => {
        if (err) {
          console.error(err);
          setError(JSON.parse(err).data);
        } else {
          setDriverAdded({
            open: true,
            modalMsg: "Driver Assigned Successfully",
            closeBtn: "Okay",
            onModalClose: () => navigate(`/lease/vehicles/vehicle-stats?idx=${vehicle}`, { replace: true }),
          })
        }
      });
    }
  }

  return (
    <>
      {!showLoading ?
        <main className="panel-main panel-card-center">
          <div className="drivers-header">
            <Breadcrumb paths={breadcrumbPaths} />
            <ClientPicker />
          </div>
          <Button onClick={() => navigate(`${PATHS.LEASE}/${PATHS.ADD_DRIVERS}`)} className="add-driver-button">
            <AddIcon className="add-icon" />
            Add New Driver
          </Button>

          <ReactTable onRowSelect={(_, rows) => setSelectedRows(rows)} showSelection={vehicle} data={drData} columns={columns} showSearch pageSize={8} showSelectAll={false} />
          {vehicle ?
            <div className="assign-btn-container">
              {error ? <p> { error } </p> : null}
              <Button className="assign-driver-btn" onClick={() => handleDriverAssign(selectedRows)} >
                Assign
              </Button>
            </div>
          : null}
          <SuccessPopupModal { ...driverAdded } />
        </main>
      : null}
    </>
  )
}

export default Profile
